module.exports = __webpack_public_path__ + "img/social-friens-request-ua.0818bf25.png";